import * as d3 from 'd3'
export default {
  methods: {

    draw_Diagram(_idx) {
      // console.log('Diagram Data ->', this.winProps.data)

      let dia = this.db_Diagram.find(f=> f.IDX == _idx)

      this.stageList = this.db_Stage.filter(f=> f.IDX == _idx)
      if(this.stageList.length ==0) {
        let message = [
          {text: `Diagram created,`},
          {text: `but no stage is registered.`},
          {text: `Do you want to register a stage now?`, color: '#B5549B'},
        ]
        // this.gmx_openPopup(this.canvasForms, {type: 'Alert', msg: message})
        this.gmx_openPopup(this.svg, {type: 'Confirm', msg: message, func: this.openStage, idx: _idx})
        return
      }
      
      // Setting Coordinates of Stage
      this.stageList.forEach(d=> {
        d.sx = d.X
        d.y = d.Y
        d.width = d.WIDTH
        d.mx = d.sx + (d.WIDTH / 2)
        d.ex = d.sx + d.WIDTH
        d.eex = d.sx +d.WIDTH + d.SPACE
      })

      this.diagramCanvas = this.canvasForms
      .append('g')
      .attr('id', `CANVAS_DIAGRAM`)
      .attr('transform', `translate(0, 0)`)
      .attr('opacity', 0)
      
      this.diagramCanvas
      .append('rect')
      .attr('x', 0).attr('y', 100)
      .attr('width', this.Canvas.CanvasWidth).attr('height', this.Canvas.CanvasHeight-100)
      .attr('fill', '#fff').attr('opacity', 1)

      this.stageList.forEach((stg, s)=> {
        let stgCanvas = this.diagramCanvas
        .append('g')
        .attr('transform', `translate(${stg.sx}, ${stg.y})`)

        this.draw_Stage(stgCanvas, stg) // -----> draw_Stage.js

        // Arrow
        if(this.stageList[s+1]) {
          this.diagramCanvas
          .append('path')
          .attr('transform', `translate(${stg.eex-7}, ${stg.y+16})`)
          .attr('d', 'M0 0 L8 4 L0 8 L0 0 Z').attr('fill', '#bcbcbc')
          this.gmx_Line(this.diagramCanvas, stg.ex, stg.eex, stg.y+20, stg.y+20, '#bcbcbc', 2, 1)
        }

        let data = this.db_Table.filter(f=> f.IDX == stg.IDX && f.STG_NO == stg.STG_NO)
        this.child_InputList (stg, data) // -----> draw_Stage.js
        this.child_ExecList  (stg, data) // -----> draw_Stage.js
        this.child_OutputList(stg, data) // -----> draw_Stage.js
      })


      // EDIT
      let edit = this.diagramCanvas
      .append('g')
      .attr('transform', `translate(1180, 70)`).attr('opacity', .5)
      .call(this.gmx_openWindow, {exeFunc: this.dia_Router, width: 900, height: 720, mode: 'edit', idx: _idx,}, 'reverse') // -----> dia_Router.js

      edit
      .append('rect')
      .attr('x', .5).attr('y', .5).attr('rx', 5).attr('ry', 5)
      .attr('width', 60).attr('height', 60).attr('fill', '#F4F5F5')
      .attr('stroke', '#757575').attr('stroke-width', .3).attr('opacity', .5)

      edit
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Edit_Diagram.svg`).attr('width', 60)


      // CUTOFF
      let calendar = this.diagramCanvas
      .append('g')
      .attr('transform', `translate(1260, 70)`)
      .call(this.exec_Procedure, 'CUTOFF', dia)

      let updated = dia.CTO_DATE ? new Date(dia.CTO_DATE) : null

      calendar
      .append('rect')
      .attr('x', .5).attr('y', .5).attr('rx', 5).attr('ry', 5)
      .attr('width', 60).attr('height', 60).attr('fill', '#F4F5F5')
      .attr('stroke', '#757575').attr('stroke-width', .3).attr('opacity', .5)

      calendar
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Calender.svg`).attr('width', 60)

      calendar
      .append('text')
      .attr('id', 'CUTOFF_MONTH')
      .attr('x', 31).attr('y', 16.5)
      .attr('fill', '#fff').attr('font-size', 9).attr('text-anchor', 'middle')
      .text(updated ? updated.toLocaleString('en-US', { month: 'short' }) : '')

      calendar
      .append('text')
      .attr('id', 'CUTOFF_DAY')
      .attr('x', 31).attr('y', 36)
      .attr('fill', '#EC407A').attr('font-size', 16).attr('text-anchor', 'middle')
      .text(updated ? updated.getDate() : '')


      // VERIFY
      let verify = this.diagramCanvas
      .append('g')
      .attr('transform', `translate(1340, 70)`)
      .call(this.exec_Procedure, 'VERIFY', dia)

      verify
      .append('rect')
      .attr('x', .5).attr('y', .5).attr('rx', 5).attr('ry', 5)
      .attr('width', 60).attr('height', 60).attr('fill', '#F4F5F5')
      .attr('stroke', '#757575').attr('stroke-width', .3).attr('opacity', .5)

      verify
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Verify.svg`).attr('width', 60)


      // DEV SERVER
      let dev = this.diagramCanvas
      .append('g')
      .attr('transform', `translate(1420, 70)`)
      .call(this.exec_Procedure, 'DEV', dia)

      dev
      .append('rect')
      .attr('x', .5).attr('y', .5).attr('rx', 5).attr('ry', 5)
      .attr('width', 60).attr('height', 60).attr('fill', '#F4F5F5')
      .attr('stroke', '#757575').attr('stroke-width', .3).attr('opacity', .5)
      
      dev
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Dev.svg`).attr('width', 60)


      // SERVICE SERVER
      let service = this.diagramCanvas
      .append('g')
      .attr('transform', `translate(1500, 70)`)
      .call(this.exec_Procedure, 'SERVICE', dia)

      service
      .append('rect')
      .attr('x', .5).attr('y', .5).attr('rx', 5).attr('ry', 5)
      .attr('width', 60).attr('height', 60).attr('fill', '#F4F5F5')
      .attr('stroke', '#757575').attr('stroke-width', .3).attr('opacity', .5)

      service
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/svg/Server_Service.svg`).attr('width', 60)

      this.sitemap_Router(dia)
    },


  }
}